import { CallWidgetStates } from 'calling-internal-common/widget-status/constants/CallWidgetStates';
import { CallDirection } from 'calling-internal-common/constants/CallDirection';
import { UPDATE_CALL_STATUS, UPDATE_CALL_DIRECTION, USER_AVAILABLE, USER_UNAVAILABLE, LOGGED_IN, LOGGED_OUT, RESET_WIDGET_DETAILS, UPDATE_WIDGET_DETAILS, REPLACE_WIDGET_DETAILS, RESET_REMOTE_CONNECTION } from '../actions/ActionTypes';
import { useCallback } from 'react';
export const useDispatch = dispatch => {
  const setThirdPartyInbound = useCallback(() => dispatch({
    type: UPDATE_CALL_DIRECTION,
    payload: CallDirection.INBOUND
  }), [dispatch]);
  const setThirdPartyOutbound = useCallback(() => dispatch({
    type: UPDATE_CALL_DIRECTION,
    payload: CallDirection.OUTBOUND
  }), [dispatch]);
  return {
    setThirdPartyCallStatus: useCallback(payload => {
      if (payload === CallWidgetStates.INCOMING_INBOUND_CALL) {
        setThirdPartyInbound();
      } else if (payload === CallWidgetStates.INITIALIZING_OUTBOUND_CALL) {
        setThirdPartyOutbound();
      }
      dispatch({
        type: UPDATE_CALL_STATUS,
        payload
      });
    }, [dispatch, setThirdPartyInbound, setThirdPartyOutbound]),
    setThirdPartyIsLoggedIn: useCallback(() => {
      dispatch({
        type: LOGGED_IN
      });
    }, [dispatch]),
    setThirdPartyIsLoggedOut: useCallback(() => {
      dispatch({
        type: LOGGED_OUT
      });
    }, [dispatch]),
    setThirdPartyUserAvailable: useCallback(() => {
      dispatch({
        type: USER_AVAILABLE
      });
    }, [dispatch]),
    setThirdPartyUserUnavailable: useCallback(() => {
      dispatch({
        type: USER_UNAVAILABLE
      });
    }, [dispatch]),
    resetWidgetDetails: useCallback(() => {
      dispatch({
        type: RESET_WIDGET_DETAILS
      });
    }, [dispatch]),
    updateWidgetDetails: useCallback(payload => {
      dispatch({
        type: UPDATE_WIDGET_DETAILS,
        payload
      });
    }, [dispatch]),
    replaceWidgetDetails: useCallback(payload => {
      dispatch({
        type: REPLACE_WIDGET_DETAILS,
        payload
      });
    }, [dispatch]),
    resetRemoteConnection: useCallback(() => {
      dispatch({
        type: RESET_REMOTE_CONNECTION
      });
    }, [dispatch])
  };
};